import { render, staticRenderFns } from "./comment_popover.vue.js?vue&type=template&id=17c48c21!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./comment_popover.vue?vue&type=template&id=17c48c21"
import script from "./comment_popover.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./comment_popover.vue?vue&type=script&lang=js"
export * from "./comment_popover.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./comment_popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17c48c21')) {
      api.createRecord('17c48c21', component.options)
    } else {
      api.reload('17c48c21', component.options)
    }
    module.hot.accept("./comment_popover.vue.js?vue&type=template&id=17c48c21!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./comment_popover.vue?vue&type=template&id=17c48c21", function () {
      api.rerender('17c48c21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "issuable/popover/components/comment_popover.vue"
export default component.exports